import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IconProps {
  color?: string;
  fontSize?: string;
}

export const IconStyled = styled(FontAwesomeIcon)<IconProps>`
  color: ${({ color }) => color};
  font-size: ${({ fontSize }) => fontSize};
`;
export const UnstyledButton = styled.button`
  background: unset;
  border: none;
`;
